import { IFontFace } from '/druid/IRawStyleBase';
import { getStyleOptions } from '/druid/StyleOptionsState';
import { Stylesheet } from '/druid/Stylesheet';
import { serializeRuleEntries } from '/druid/styleToClassName';

/**
 * Registers a font face.
 * @public
 */
export function fontFace(font: IFontFace): void {
  Stylesheet.getInstance().insertRule(`@font-face{${serializeRuleEntries(getStyleOptions(), font as {})}}`, true);
}
